import {
  SYNTHETIC_DATA_DEMO_USER_PROMPT,
} from './syntheticDataDemoContent.js'

/** @param {string} trimmed @param {unknown[] | undefined} [_files] */
export function isSyntheticDataDemoPrompt(trimmed, _files) {
  const normalized = String(trimmed ?? '').trim().toLowerCase()
  return (
    normalized === SYNTHETIC_DATA_DEMO_USER_PROMPT.toLowerCase() ||
    (normalized.includes('synthetic data') && normalized.includes('outperform'))
  )
}
